import { IconProps } from '../../types/IconProps';

export const ChevronDown = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    className={`${className || ''}`}>
    <path
      fill={variant === 'light' ? '#fff' : '#0B223E'}
      d='M2.938 7.07a.846.846 0 0 1 1.197 0L12 14.936l7.864-7.866a.847.847 0 1 1 1.197 1.198l-8.463 8.463a.846.846 0 0 1-1.197 0L2.938 8.268a.846.846 0 0 1 0-1.198Z'
    />
  </svg>
);
